import { createFileRoute } from "@tanstack/react-router";
import { SiteNav } from "@/components/site-nav";

const TITLE = "Mine Talent 2026 · El talento que transforma la minería | Mine Class";
const DESC =
  "Encuentro sobre identificación, atracción y desarrollo de talento minero. Miércoles 16 de diciembre, 08:30 hrs, Hotel Terrado, Antofagasta. Inscripción abierta, cupos limitados.";
const URL = "https://mine-class.com/comunicaciones/eventos/mine-talent";
const IMG = "https://mine-class.com/eventos/mine-talent-2026/assets/hero.webp";

export const Route = createFileRoute("/comunicaciones/eventos/mine-talent")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:url", content: URL },
      { property: "og:type", content: "website" },
      { property: "og:image", content: IMG },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:image", content: IMG },
    ],
    links: [{ rel: "canonical", href: URL }],
  }),
  component: Page,
});

function Page() {
  return (
    <div className="flex h-screen flex-col">
      <SiteNav />
      <main className="flex-1">
        <h1 className="sr-only">Mine Talent 2026 · El talento que transforma la minería</h1>
        <iframe
          src="/eventos/mine-talent-2026/landing.html"
          title="Mine Talent 2026 · El talento que transforma la minería"
          className="h-full w-full border-0"
        />
      </main>
    </div>
  );
}
